import TemplateView from '../../../TemplateView'
import {atImgPath} from '../../../atBrowserUtils'

export default class DescriptionBlock extends TemplateView {
    constructor({
        extraClass = '',
        name,
        text,
        imageTopDescription = '',
        imageBottomDescription = '',
    }) {
        super()

        this.params = {
            extraClass,
            text,
            name,
            imageTopDescription,
            imageBottomDescription,
        }
    }

    templateHtml() {
        return '<div class="note <%=extraClass%>">' +
               '  <div class="name"><%-name%></div>' +
               '  <div class="text"><%-text%></div>' +
               '  <div class="imageTopDescription"><%-topDescription%></div>' +
               '  <div class="imgPlaceholder"/>' +
               '  <div class="imageBottomDescription"><%-bottomDescription%></div>' +
               '</div>'
    }

    templateModel() {
        return {
            extraClass: this.params.extraClass,
            name: this.params.name,
            text: this.params.text,
            topDescription: this.params.imageTopDescription,
            bottomDescription: this.params.imageBottomDescription,
        }
    }

}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/components/DescriptionBlock.js